module.exports = __webpack_public_path__ + "img/person-checkmark_fill.1920f7c4.svg";